const getPosWebsocketConnectionUrl = () => {
  switch (process.env.REACT_APP_ENV) {
    case "dev":
      return `wss://qajulexq97.execute-api.ap-southeast-1.amazonaws.com/dev`;
    case "staging":
      return `wss://re1nbyan7i.execute-api.us-east-2.amazonaws.com/staging`;
    case "prod":
      return `wss://jrc42e13fk.execute-api.us-east-1.amazonaws.com/prod`;
    default:
      return `wss://jrc42e13fk.execute-api.us-east-1.amazonaws.com/prod`;
  }
};

const websocketServices = {
  getPosWebsocketConnectionUrl,
};

export default websocketServices;
